module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-3f16e9b2da8a23820cb7cd1a3d151080.png";